var _defs, _path, _path2, _polygon, _polygon2, _polygon3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCierrepasoHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 681.5 166.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #a00707;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M503.7,165L665.8,2.3c10,3.6,12.3,9.5,13.2,19.4,3.6,40.5-2.8,86.6-.2,127.7.6,5.1-9.2,15.5-12.9,15.5h-162.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M177.9,1.7C157.4,18.8,27.2,161.6,15.9,162.5c-8.9.7-12.6-10.4-13.2-17.5-3.9-40.1,3.1-86.9.3-127.8C2.3,12.2,12.1,1.7,15.8,1.7h162.1,0Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "468.3 1.7 464.7 8.8 308.5 164.9 222.2 164.9 384.3 1.7 468.3 1.7"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "326.3 1.7 322.8 8.8 166.6 164.9 82.6 164.9 86.2 157.8 242.3 1.7 326.3 1.7"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "610.2 1.7 448.1 164.9 364.2 164.9 526.2 1.7 610.2 1.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCierrepasoHorizontal);
export default __webpack_public_path__ + "static/media/CIERRE PASO-HORIZONTAL.07035c01d1f7d0d1407c782654537595.svg";
export { ForwardRef as ReactComponent };